const e = {
  day: "day",
  hour: "hour",
  minute: "minute",
  seconds: "seconds",
  value: "value",
  valueSingle: "valueSingle",
  percent: "percent",
  valuePerHour: "valuePerHour"
};
export {
  e as units
};
